module.exports = __webpack_public_path__ + "d4f2bf2eff4f11652ef134cc4cdcb134.ttf";